import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { retrieveFromCart, updateCart, removeFromCart } from "./api";
import { GraphQLClient } from "graphql-request";
import Header from "../Components/header";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Cart = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [cart, setCart] = useState(null);
  const [totalPrice, setTotalPrice] = useState(0);
  useEffect(() => {
    const retrieveCart = async () => {
      try {
        const response = await retrieveFromCart();
        console.log("Lunghezza:", response.length);
        let totalPrice = 0; // Initialize totalPrice

        const productsWithImages = await Promise.all(
          response.map(async (item) => {
            const urlCopertina = await fetchProduct(item.hygraph_id);
            totalPrice += item.prezzo * item.quantity;
            return { ...item, url_copertina: urlCopertina };
          })
        );

        setCart(productsWithImages);
        setTotalPrice(totalPrice);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // L'utente non è autenticato
          return false;
        }
      }
    };

    retrieveCart();
  }, []);

  const fetchProduct = async (hygraph_id, i) => {
    console.log(hygraph_id);
    const client = new GraphQLClient(
      "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
    );
    const query = `
    query MyQuery($hygraph_id: ID!) {
        riviste(where: {id: $hygraph_id}) {
          copertina {
            url
          }
        }
        abbonamenti(where: {id: $hygraph_id}) {
          copertina {
            url
          }
        }
      }
      `;

    try {
      const data = await client.request(query, { hygraph_id });
      if (data.riviste) {
        return data.riviste.copertina.url;
      } else {
        return data.abbonamenti.copertina.url;
      }
    } catch (error) {
      console.error("Error fetching product:", error);
    }
  };

  const incrementQuantity = async (index) => {
    const newCart = [...cart];
    newCart[index].quantity += 1;
    setCart(newCart);
    calculateTotalPrice(newCart);
    await updateCart(newCart[index].id, newCart[index].quantity);
  };

  const decrementQuantity = async (index) => {
    const newCart = [...cart];
    if (newCart[index].quantity > 1) {
      newCart[index].quantity -= 1;
    }
    setCart(newCart);
    calculateTotalPrice(newCart);
    await updateCart(newCart[index].id, newCart[index].quantity);
  };

  const calculateTotalPrice = (cart) => {
    const total = cart.reduce(
      (sum, item) => sum + item.prezzo * item.quantity,
      0
    );
    setTotalPrice(total);
  };

  const handleRemoveFromCart = async (id_prodotto) => {
    try {
      console.log(id_prodotto);
      await removeFromCart(id_prodotto);
      window.location.reload();
    } catch (err) {
      console.log("IMPOSSIBILE AGGIUNGERE AL CARRELLO:", err);
    }
  };

  if (isLoading) {
    return (
      <div>
        <Header />
        <div className="flex flex-col justify-center items-center">
          <p className="text-4xl font-semibold mt-10 text-gray-700">Carrello</p>
          <table className="w-[90%] max-w-6xl mt-14 text-left border-collapse ...">
            <thead>
              <tr>
                <th className="text-left e pl-10  border-b border-slate-300 pb-2 sm:pb-5 ">
                  Titolo
                </th>
                <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                  Prezzo
                </th>
                <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                  Quantità
                </th>
                <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                  Totale
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 3 }).map((_, index) => (
                <tr key={index}>
                  <td className="border-b p-2 sm:p-10 border-slate-300 flex flex-row items-center">
                    <Skeleton width={"110px"} height={"150px"} />

                    <div className="ml-2 sm:ml-10 flex flex-col justify-center items-start ">
                      <p className="text-sm sm:text-xl text-gray-600">
                        <Skeleton width={"200px"} height={"20px"} />
                      </p>
                      <Skeleton width={"90px"} height={"30px"} />
                    </div>
                  </td>
                  <td className="text-center text-sm sm:text-xl p-2 sm:p-10 border-b border-slate-300">
                    <Skeleton width={"40px"} height={"30px"} />
                  </td>

                  <td className="text-center border-b border-slate-300">
                    <div className="flex flex-col items-center justify-center">
                      <Skeleton width={"20px"} height={"20px"} />
                      <Skeleton width={"20px"} height={"20px"} />
                      <Skeleton width={"20px"} height={"20px"} />
                    </div>
                  </td>

                  <td className="text-center text-sm sm:text-xl p-2 sm:p-10 border-b border-slate-300">
                    <Skeleton width={"40px"} height={"30px"} />
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="3"></td>
                <td className="text-center text-sm sm:text-xl p-2 sm:p-10">
                  <Skeleton width={"40px"} height={"30px"} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="flex flex-col justify-center items-center">
        <p className="text-4xl font-semibold mt-10 text-gray-700">Carrello</p>
        <table className="w-[90%] max-w-6xl mt-14 text-left border-collapse ...">
          <thead>
            <tr>
              <th className="text-left e pl-10  border-b border-slate-300 pb-2 sm:pb-5 ">
                Prodotto
              </th>
              <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                Prezzo
              </th>
              <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                Quantità
              </th>
              <th className="text-center border-b border-slate-300 pb-2 sm:pb-5">
                Totale
              </th>
            </tr>
          </thead>
          {cart && cart.length > 0 ? (
            <tbody>
              {cart.map((rivista, index) => (
                <tr key={rivista.id}>
                  <td className="border-b p-2 sm:p-10 border-slate-300 flex flex-row items-center">
                    <img
                      src={rivista.url_copertina}
                      alt={rivista.id}
                      className="w-20 sm:w-32 h-auto"
                    ></img>
                    <div className="ml-2 sm:ml-10 flex flex-col justify-center items-start ">
                      <p className="text-sm sm:text-xl text-gray-600">
                        {rivista.titolo}
                      </p>
                      <button
                        className="mt-2 border rounded sm:px-2 px-4 py-1 sm:py-2 text-xs font-semibold border-black"
                        onClick={() => handleRemoveFromCart(rivista.id)}
                      >
                        RIMUOVI
                      </button>
                    </div>
                  </td>
                  <td className="text-center text-sm sm:text-xl p-2 sm:p-10 border-b border-slate-300">
                    €{rivista.prezzo}
                  </td>
                  {rivista.titolo
                    .toLowerCase()
                    .includes("abbonamento".toLowerCase()) ? (
                    <td className="border-b border-slate-300" colSpan={1} />
                  ) : (
                    <td className="text-center border-b border-slate-300">
                      <div className="flex flex-col items-center justify-center">
                        <button
                          onClick={() => incrementQuantity(index)}
                          className="flex justify-center items-center transition hover:bg-[#f3f9ff] border rounded w-8 sm:w-10 h-8 sm:h-10 text font-semibold text-[#4097fe] border-none cursor-pointer "
                        >
                          +
                        </button>
                        <span>{rivista.quantity}</span>

                        <button
                          onClick={() => decrementQuantity(index)}
                          className="flex justify-center items-center transition hover:bg-[#f3f9ff] border rounded w-8 sm:w-10 h-8 sm:h-10 text font-semibold text-[#4097fe] border-none cursor-pointer "
                        >
                          -
                        </button>
                      </div>
                    </td>
                  )}

                  <td className="text-center text-sm sm:text-xl p-2 sm:p-10 border-b border-slate-300">
                    €{rivista.prezzo * rivista.quantity}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan="3"></td>
                <td className="text-center text-sm sm:text-xl p-2 sm:p-10">
                  €{totalPrice}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="4" className="text-center font-semibold p-10">
                  Nessun prodotto nel carrello
                </td>
              </tr>
            </tbody>
          )}
        </table>
        {cart && cart.length > 0 && (
          <div className="w-[90%] max-w-6xl mt-5 mb-20 flex justify-end">
            <Link
              to="/checkout"
              className="font-semibold px-4 py-2 border-2 text-red-500 border-red-500 hover:text-white hover:bg-red-500 transition"
            >
              CHECKOUT
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
